import { Package } from 'lucide-react';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import { SimilarProductRow } from 'src/features/novelties/components/SimilarProductRow';
import { SimilarityData } from 'src/services/api/getNoveltiesBestCandidates';

type SimilarProductsTableProps = {
  similarities: SimilarityData[];
};

export function SimilarProductsTable({
  similarities,
}: SimilarProductsTableProps): ReactElement {
  const { t } = useTranslation('novelties');

  if (similarities.length === 0) {
    return (
      <div className='flex items-center justify-center py-8 text-sm text-layout-foreground-secondary'>
        {t('No similar products found')}
      </div>
    );
  }

  return (
    <div className='space-y-3'>
      <div className='flex items-center gap-2 text-sm font-medium'>
        <Package className='size-4 text-primary-default' />
        {t('Similar Products')}
      </div>
      <div className='overflow-hidden rounded-lg border border-border-default bg-card'>
        <Table>
          <TableHeader>
            <TableRow className='bg-layout-hover h-10'>
              <TableHead className='w-12 text-xs font-semibold'></TableHead>
              <TableHead className='text-xs font-semibold'>
                {t('SKU')}
              </TableHead>
              <TableHead className='text-xs font-semibold'>
                {t('Title')}
              </TableHead>
              <TableHead className='text-center text-xs font-semibold'>
                {t('Similarity')}
              </TableHead>
              <TableHead className='text-center text-xs font-semibold'>
                {t('Avg Forecast')}
              </TableHead>
              <TableHead className='text-right text-xs font-semibold'>
                {t('Purchase Price')}
              </TableHead>
              <TableHead className='text-right text-xs font-semibold'>
                {t('Selling Price')}
              </TableHead>
              <TableHead className='text-center text-xs font-semibold'>
                {t('Attributes')}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {similarities.map((similarity) => (
              <SimilarProductRow key={similarity.sku} similarity={similarity} />
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
